/**
 * Порядок списка проектов нового дизайна — общий модуль сервера и клиента (в клиенте — алиас @projectSearch).
 * Тот же переключатель у «В работе» и у поиска (GET /api/projects?q=…&sort=…): сервер отдаёт найденное в этом порядке,
 * чтобы «Показать ещё» дописывало страницы в конец, а не перемешивало уже показанное.
 *   stage   — по этапам: Правки, Проверка, Монтаж, Запись, Добавлен, Готов;
 *   urgency — по сроку: от просроченного к дальнему, без срока — в конце;
 *   alpha   — по названию, А–Я.
 */
export const PROJECT_LIST_SORTS = ['stage', 'urgency', 'alpha'] as const;

export type ProjectListSort = (typeof PROJECT_LIST_SORTS)[number];
